module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "inp-input",
    class: {
      'error': _vm.error,
      'right': _vm.right
    }
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "required": _vm.required,
      "disabled": _vm.disabled,
      "placeholder": " "
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keydown": function($event) {
        _vm.keydown($event)
      },
      "focus": function($event) {
        _vm.focus($event)
      },
      "blur": function($event) {
        _vm.blur($event)
      },
      "paste": function($event) {
        _vm.paste($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1785800c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/InputNumber/InputNumber.vue.html
// module id = AdPv
// module chunks = 2